import { render, staticRenderFns } from "./Blocked.vue?vue&type=template&id=e9b0ba20&scoped=true&"
import script from "./Blocked.vue?vue&type=script&lang=js&"
export * from "./Blocked.vue?vue&type=script&lang=js&"
import style0 from "./Blocked.vue?vue&type=style&index=0&id=e9b0ba20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b0ba20",
  null
  
)

export default component.exports